module.exports = __webpack_public_path__ + "static/img/2_1_5.a983a7ae.jpg";